import { render, staticRenderFns } from "./ControlPropertiesPorteuses.vue?vue&type=template&id=9527bfaa&"
import script from "./ControlPropertiesPorteuses.vue?vue&type=script&lang=js&"
export * from "./ControlPropertiesPorteuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports